import { Button } from "@/components/ui/button";
import { MERCHANT_SELECTED } from "@/context/types";
import { ChevronDown, Loader2, LogOut, RefreshCcw, X } from "lucide-react";

import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router";

import AvatarIcon from "../assets/AvatarIcon.svg";

import { useAuthDispatch, useAuthState } from "@/context";
import { getMerchant } from "@/services/Home.service";
import { Storage } from "@/services/storage-services";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Command, CommandInput, CommandItem, CommandList } from "./ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const MerchantPopOver = () => {
  const queryClient = useQueryClient();
  const dispatch = useAuthDispatch();
  const { handleLogout } = useAuthState();

  const navigate = useNavigate();

  const [searchValue, setSearchValue] = useState("");
  const teams = Storage.getItem("teams");

  const user = useQuery({
    queryKey: ["merchant_user"],
    queryFn: async () => await getMerchant(),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
  const [data] = useState(user?.data?.data?.data?.teams ?? teams);

  const handlePress = async (merchantItem) => {
    queryClient.resetQueries();
    dispatch({ type: MERCHANT_SELECTED, payload: merchantItem });

    Storage.setItem("env", merchantItem?.env);
    Storage.setItem("businessId", merchantItem.businessId);
    Storage.setItem("selectedMerchant", merchantItem);

    navigate("/dashboard");
    setToggleMerchantSelector(false);
  };

  const [toggleMerchantSelector, setToggleMerchantSelector] = useState(false);

  const merchant = Storage.getItem("selectedMerchant");
  const current_user = Storage.getItem("user");

  return (
    <Popover
      onOpenChange={setToggleMerchantSelector}
      open={toggleMerchantSelector}
    >
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          className="outline-none border-none p-0"
          onClick={() => {
            setToggleMerchantSelector(true);
          }}
        >
          <div className="flex items-center gap-1 h-9">
            <Avatar className="w-8 h-8">
              <AvatarImage />
              <AvatarFallback className="text-sm">
                {merchant?.businessName[0]}
              </AvatarFallback>
            </Avatar>
            <div className="flex flex-col items-start">
              <p className="text-xs capitalize text-primary">
                {merchant?.roleId?.split("-")[1]}
              </p>

              <div className="flex items-center gap-0">
                <p className="text-sm font-medium">{merchant?.businessName}</p>

                {toggleMerchantSelector ? (
                  <X />
                ) : (
                  <ChevronDown className="w-3 h-3" />
                )}
              </div>
            </div>
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full h-[350px] p-2 pt-3 mr-3">
        <Command>
          <span className="text-xs text-text-soft-400 font-medium">
            Switch to other business accounts
          </span>
          <div
            className="flex items-center 
               border-border p-2 border-[1px] rounded-[8px] gap-2 w-full h-8
              "
          >
            <CommandInput
              value={searchValue}
              onValueChange={setSearchValue}
              placeholder="Search for business..."
              className="w-full h-fit px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
            />
          </div>

          <CommandList className="w-full pt-2 flex flex-col items-start gap-4 justify-between h-full">
            {data?.filter((option) =>
              option?.businessName?.toLowerCase()?.startsWith(searchValue)
            )
              ?.map((option) => (
                <CommandItem
                  key={option?.id}
                  className={`text-sm  z-50 border-b-[1px] cursor-pointer
                    rounded-none hover:bg-transparent w-[280px]
                    p-2
              ${option?.businessName?.toLowerCase()?.startsWith(searchValue)
                      ? "block"
                      : "hidden"
                    }`}
                  onSelect={() => {
                    handlePress(option);
                    setSearchValue("");
                    setToggleMerchantSelector(false);
                  }}
                >
                  <div className="flex flex-row items-center justify-between w-full gap-3 ">
                    <div className="flex flex-row items-center justify-start gap-3">
                      <div className="w-10 h-10">
                        <img src={AvatarIcon} />
                      </div>
                      <div className="flex flex-col items-start">
                        <span className="text-sm font-medium text-main-900">
                          {option?.businessName} - {option?.businessId}
                        </span>

                        <span className="text-xs text-[#525866]">
                          {current_user?.email}
                        </span>
                      </div>
                    </div>
                    <div className="bg-[#F6F8FA] px-2 py-[2px] rounded-3xl h-4 text-[#525866] text-center text-[11px] leading-[12px]">
                      {option?.roleId?.split("-")[1]}
                    </div>
                  </div>
                </CommandItem>
              ))}
          </CommandList>
          <div className="mt-auto w-full grid gap-3">
            <Button
              className=" mt-4 w-full bg-green h-10"
              onClick={() => user?.refetch()}
              disabled={user?.isFetching}
            >
              {user?.isFetching && <Loader2 className="animate-spin" />}
              <RefreshCcw />
              <span>Refresh List</span>
            </Button>
            <Button
              className="w-full bg-error "
              onClick={() => {
                handleLogout();
                navigate("/");
              }}
            >
              <LogOut className="w-3 h-3" /> Logout
            </Button>
          </div>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default MerchantPopOver;
